var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShuffleSimple = function SvgIconShuffleSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.207 3.793a1 1 0 0 0-1.414 1.414L17.086 18.5H15.75a1 1 0 1 0 0 2h3.753a1 1 0 0 0 .704-.293 1 1 0 0 0 .293-.704V15.75a1 1 0 1 0-2 0v1.336zM15.36 10.054l3.14-3.14V8.25a1 1 0 1 0 2 0V4.52a.997.997 0 0 0-1-1.02h-3.75a1 1 0 1 0 0 2h1.336l-3.14 3.14a1 1 0 0 0 1.414 1.414M10.054 15.36a1 1 0 0 0-1.414-1.414l-4.847 4.847a1 1 0 0 0 1.414 1.414z"
  }))));
};
export default SvgIconShuffleSimple;